<template>
  <div class="api-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <!-- <el-select v-model="form.sort" placeholder="请选择" style="width: 160px; display: inline-block;">
            <el-option
              v-for="item in options"
              :key="item.sort"
              :label="item.name"
              :value="item.sort">
            </el-option>
          </el-select> -->
          <el-input
            v-model="form.value"
            placeholder="请输入接口名称"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('add')"
            v-hasPermi="['API接口管理', '新增']"
            >新增数据</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="api_name"
          label="API名称"
          min-width="140"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="url"
          label="接口路径"
          min-width="250"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="request_type" label="请求类型" align="center">
        </el-table-column>
        <el-table-column prop="api_type" label="接口类型" align="center">
        </el-table-column>
        <el-table-column prop="status" label="完成状态" align="center">
          <template slot-scope="scope">
            <span v-show="scope.row.status == 0">未完成</span>
            <span v-show="scope.row.status == 1">已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="creater" label="创建人" align="center">
        </el-table-column>
        <!-- <el-table-column
          label="字段"
          align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span class="btn read">查看</span>
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="daily_call"
          label="日调用次数"
          align="center">
        </el-table-column>
        <el-table-column
          prop="reponse_time"
          label="平均响应时间"
          align="center">
        </el-table-column> -->
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                @click="readClick(scope.row.id)"
                v-hasPermi="['API接口管理', '详情']"
                >查看</span
              >
              <span
                class="btn read"
                @click="deleteClick(scope.row.id)"
                v-hasPermi="['API接口管理', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import { GetApiList, GetSortList, deleteApiData } from '@/api/api'
export default {
  data () {
    return {
      form: {
        value: '',
        sort: ''
      },
      loading: false,
      options: [
        { name: '默认', sort: '' }
      ],
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      },
    }
  },
  created () {
    this.getSortData()
    this.getData()
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
  },
  methods: {
    getSortData () {
      GetSortList()
        .then(res => {
          this.options = this.options.concat(res.data)
        })
    },
    getData () {
      this.loading = true
      const params = { start: this.table.currentPage, size: this.table.size }
      this.form.sort ? params.sort = this.form.sort : ''
      this.form.value ? params.api_name = this.form.value : ''
      GetApiList(params)
        .then(res => {
          this.loading = false
          const data = res.data
          this.table.data = data.content
          this.table.total = data.total
          this.$refs.tables.bodyWrapper.scrollTop = 0
        })
    },
    search () {
      this.table.currentPage = 1
      this.getData()
    },
    currentChange () {
      this.getData()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.getData()
    },
    readClick (id) {
      this.$router.push({ name: 'ApiDetail', query: { id: id } })
    },
    deleteClick (id) {
      MessageBox.confirm('此操作将删除API信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = { id: id }
        deleteApiData(param).then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功!')
            this.refresh()
          }
        })
      }).catch(() => {
        this.$message('已取消注销')
      });
    },
    refresh () {
      this.getData()
    }
  }

}
</script>

<style lang="less" scoped>
.api-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.api-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
